<template>
  <v-card>
    <v-row class="mx-auto">
      <v-col
        cols="12"
        md="8"
        class="d-flex flex-column"
      >
        <div class="d-flex align-center justify-space-between">
          <div>
            <span class="text-lg font-weight-semibold"> Informações do Formulário </span>
            <v-btn
              icon
              class="mr-16 ml-4 text-left"
              color="primary"
              @click="isInfoDialogOpen = !isInfoDialogOpen"
            >
              <v-icon>
                {{ icons.mdiPencilBoxOutline }}
              </v-icon>
            </v-btn>
          </div>

          <v-checkbox
            v-model="formularioDataLocale.formularioBot"
            class="ml-16"
            label="Formulário Bot?"
            @change="onSubmit"
          ></v-checkbox>

          <v-switch
            v-model="formularioDataLocale.ativo"
            class="ml-16"
            :label="`Status: ${formularioDataLocale.ativo ? 'Ativo' : 'Inativo'}`"
            @change="onSubmit"
          >
          </v-switch>
        </div>

        <v-divider></v-divider>

        <div class="d-flex flex-column my-2">
          <div>
            <span class="font-weight-medium me-2">Nome:</span>
            <span class="text--secondary">
              {{ formularioDataLocale.nome }}
            </span>
          </div>

          <div>
            <span class="font-weight-medium me-2">Descrição:</span>
            <span class="text--secondary">
              {{ formularioDataLocale.descricao }}
            </span>
          </div>
        </div>

        <formulario-info-edit
          :key="formularioDataLocale.id"
          :formulario-data="formularioDataLocale"
          :is-info-dialog-open.sync="isInfoDialogOpen"
          @refresh-data="$emit('refresh-data')"
        ></formulario-info-edit>
      </v-col>

      <v-col
        cols="12"
        md="4"
        class=""
      >
        <div class="d-flex justify-space-around ml-10">
          <v-btn
            icon
            color="primary"
            @click="isConfigurarSecaoDialogOpen = !isConfigurarSecaoDialogOpen"
          >
            <v-icon>
              {{ icons.mdiFormSelect }}
            </v-icon>
            Criar seção
          </v-btn>

          <v-btn
            icon
            color="error"
            :to="{ name: 'formularios' }"
          >
            <v-icon>{{ icons.mdiCloseCircleOutline }}</v-icon>
          </v-btn>
        </div>

        <configurar-secao-dialog
          :is-configurar-secao-dialog-open.sync="isConfigurarSecaoDialogOpen"
          :secao-data="modelSecaoPersonalizada"
          @secao-criada="$emit('secao-criada')"
          @refetch-data="$emit('refetch-data')"
        >
        </configurar-secao-dialog>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import {
  mdiPencilBoxOutline,
  mdiCloseCircleOutline,
  mdiFormSelect,
} from '@mdi/js'
import { ref } from '@vue/composition-api'
import { required } from '@core/utils/validation'
import router from '@/router'
import SecaoPersonalizadaClass from '@/models/entities/formulario/secao/SecaoPersonalizada'
import FormularioInfoEdit from './FormularioInfoEdit.vue'
import ConfigurarSecaoDialog from '@/views/formulario/secoes/ConfigurarSecaoDialog.vue'
import FormularioService from '@/services/modules/FormularioService'

export default {
  components: {
    FormularioInfoEdit,
    ConfigurarSecaoDialog,
  },

  props: {
    formularioData: {
      type: Object,
      default: () => { },
    },
  },

  setup(props, { emit }) {
    const isInfoDialogOpen = ref(false)
    const isConfigurarSecaoDialogOpen = ref(false)

    const modelSecaoPersonalizada = new SecaoPersonalizadaClass({ idFormulario: parseInt(router.currentRoute.params.id, 10) })
    const valid = ref(true)
    const loading = ref(false)

    const formularioDataLocale = ref(props.formularioData)
    const cancelar = () => {
      router.push({ name: 'formularios' })
    }

    const onSubmit = async () => {
      if (loading.value) return

      loading.value = true

      if (valid.value) {
        try {
          await FormularioService.update(router.currentRoute.params.id, formularioDataLocale.value)

          setTimeout(() => {
            loading.value = false
          }, 1000)
          emit('refresh-data')
        } catch {
          loading.value = false
          emit('refresh-data')
        }
      } else {
        loading.value = false
      }
    }

    return {
      valid,
      loading,
      cancelar,
      formularioDataLocale,
      isInfoDialogOpen,
      onSubmit,
      modelSecaoPersonalizada,
      isConfigurarSecaoDialogOpen,
      icons: {
        mdiCloseCircleOutline,
        mdiPencilBoxOutline,
        mdiFormSelect,
      },
      validators: {
        required,
      },
    }
  },
}
</script>

<style>
.v-btn__content {
  display:flex;
  flex-direction:column;
}

</style>
